<template>
  <div class="modal fade" id="largeModal" tabindex="-1" :class="modalShow ? 'show' : ''" @click="closeModalCheckChild">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel3">{{ modalTitle }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" :class="modalShow ? 'show' : ''"></div>
</template>
<script>
import { VOnClickOutside as ClickOutside } from "@/helpers/directives/clickOutside"

export default {
  name: "BaseModal",
  data() {
    return {
      modalShow: false
    }
  },
  props: {
    modalTitle: {
      type: String
    },
    opened: {
      type: Boolean,
      default: false
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeModal() {
      if(this.modalShow){
        this.modalShow = false
      }
    },
    closeModalCheckChild(e) {
      if(this.closeOnBackdrop && e.target.id === 'largeModal'){
        this.closeModal()
      }
    },
    openModal(){
      setTimeout(() => this.modalShow = true, 100)
    }
  },
  directives: {
    ClickOutside
  },
  mounted() {
    if(this.opened){
      this.openModal()
    }
  }
}
</script>
<style scoped>
.modal.show{
  display: block;
}
.modal-backdrop{
  display: none;
}
.modal-backdrop.show{
  display: block;
}
</style>